import Box from '@totallymoney/ui/components/Box'
import Card from '@totallymoney/ui/components/Card'
import Stack from '@totallymoney/ui/components/Stack'
import Text from '@totallymoney/ui/components/Text'

import { ActiveCreditCard } from '@appTypes/EligibilityApi.interface'

import CardTableImage from '@components/CardTableImage'

interface HighlightHeroIneligibleProps {
    item: ActiveCreditCard | null
    totalCreditCards: number
}

const HighlightHeroIneligible = ({
    item,
    totalCreditCards,
}: HighlightHeroIneligibleProps) => {
    const offerText = totalCreditCards === 1 ? 'offer' : 'offers'

    return (
        <Card bg="white" py="space30" px={['spacingM', 'spacingML']}>
            <Box display="grid" gridAutoColumns="1fr">
                {item != null ? (
                    <Box
                        position="relative"
                        gridColumn={['1/7', '1/6', '1/3']}
                        gridRow={['2', 'unset', 'span 2']}
                        pr="space10"
                        display="flex"
                        alignItems={['flex-start', 'flex-start', 'center']}
                    >
                        <CardTableImage
                            cmsImageUrl={item.imageUrlLarge}
                            name={item.name}
                            isPortraitImage={false}
                        />
                    </Box>
                ) : null}

                <Box
                    gridColumn={[
                        'span 12',
                        item != null ? '1/9' : 'span 12',
                        item != null ? '3/13' : 'span 12',
                    ]}
                    gridRow={['unset', '1', 'span 2']}
                    display={['block', 'flex']}
                    justifyContent={['unset', 'flex-start', 'center']}
                    flexDirection={'column'}
                    mb={['spacingS', 'spacingS', 0]}
                    px={[0, 0, item != null ? 'spacingM' : 0]}
                >
                    <Stack space="space05">
                        <Text variant="140">
                            Unfortunately you’re not eligible for the{' '}
                            <strong>{item?.name ?? 'card'}</strong>.
                        </Text>
                        <Text variant="120" color="light">
                            {totalCreditCards > 0 ? (
                                <>
                                    This could be for a number of reasons.
                                    However, we have {totalCreditCards} other
                                    card {offerText} below that you are eligible
                                    for.
                                </>
                            ) : (
                                <>This could be for a number of reasons.</>
                            )}
                        </Text>
                    </Stack>
                </Box>
            </Box>
        </Card>
    )
}

export default HighlightHeroIneligible
